export default {
  data() {
    return {
      YFCXForm: {
        ywjszyzh: "",
        ywzzyfdxcp: "",
        ywgjhzhcxy: "",
        sfyyfry: "",
        yfry: "",
        yfryslbd: ""
      },
      YFCXRules: {
        yfry: [
          {
            required: true,
            message: "请选择研发人员",
            trigger: ["blur", "change"]
          }
        ],
        yfryslbd: [
          {
            required: true,
            message: "请选择研发人员数量变动",
            trigger: ["blur", "change"]
          }
        ]
      },
      yfryList: [
        { name: "10人以下（含10人）", code: "ygrs_1" },
        { name: "10-50人（含50人）", code: "ygrs_2" },
        { name: "50-200人（含200人）", code: "ygrs_3" },
        { name: "200-500人（含500人）", code: "ygrs_4" },
        { name: "500-1000人（含1000人）", code: "ygrs_5" },
        { name: "1000人以上", code: "ygrs_6" }
      ],
      yfryslbdList: [
        { name: "增加1%-10%（含1%）", code: "1" },
        { name: "增加10%-20%（含10%）", code: "2" },
        { name: "增加10%-20%（含10%）", code: "3" },
        { name: "减少1%-10%（含1%）", code: "4" },
        { name: "减少10%-20%（含10%）", code: "5" },
        { name: "减少20%以上（含20%）", code: "6" }
      ]
    };
  },
  methods: {
    sfyyfryChange() {
      this.YFCXForm.yfry = "";
      this.YFCXForm.yfryslbd = "";
      this.$refs["YFCXForm"].clearValidate();
    }
  }
};
